import React from 'react'
import { Box, Container, Typography, Button } from '@material-ui/core'

import { useStyles } from 'styles/styles'
import { useTextLookup } from 'utils/text'
import AppHeader from 'components/widgets/AppHeader'
import TopicSelectorWidget from 'components/topics/TopicSelectorWidget'

interface TopicSelectorPageProps {
    onSelectTopic: (topicId: number) => void
    onSelectCountry: () => void
}

const TopicSelectorPage: React.FC<TopicSelectorPageProps> = (props) => {
    const classes = useStyles()
    const _t = useTextLookup()

    const handleSelectTopic = (topicId: number) => {
        props.onSelectTopic(topicId)
    }

    const handleSelectCountry = () => {
        props.onSelectCountry()
    }

    return (
        <Box component="main">
            <Box className={classes.pageHeading}>
                <Container maxWidth="lg">
                    <AppHeader />
                    <Typography variant='h3' color='primary'>{_t("topic_selector.title")}</Typography>
                    <Typography className={classes.paragraph}>{_t("topic_selector.heading")}</Typography>
                </Container>
            </Box>
            <Box>
                <Box className={classes.topicsSelectorPadding}>
                    <TopicSelectorWidget  onSelectTopic={handleSelectTopic} />
                </Box>

                <Container maxWidth="lg">
                    <Button variant="contained" onClick={handleSelectCountry}>{_t("topic_selector.button")}</Button>
                </Container>
            </Box>
        </Box>
    )
}

export default TopicSelectorPage
